import {NgModule} from '@angular/core';
import {KeeniconComponent} from './keenicon/keenicon.component';
import {CommonModule} from "@angular/common";
import { PaginationComponent } from './pagination/pagination.component';
import { FormsModule } from '@angular/forms';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CalendarModule } from 'primeng/calendar';

@NgModule({
  declarations: [
    KeeniconComponent,
    PaginationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    InputSwitchModule,
    DropdownModule,
    SelectButtonModule,
    CalendarModule
  ],
  exports: [
    KeeniconComponent,
    PaginationComponent,
    InputSwitchModule,
    DropdownModule,
    SelectButtonModule,
    CalendarModule
  ]
})
export class SharedModule {
}
